/* eslint-disable no-undef */
import './index.scss';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// import { number } from 'prop-types';
import {
  generatePhoneOtp,
  getSignup,
  getUpdateUser,
  getUserDetail,
  getVerifyOtp,
  signUpWithEmail
} from '../../burger-king-lib/redux/login/actions';
import Loader from '../../components/loader-backdrop';
import LoginNumber from '../../components/login-mobile-number';
import LoginOrder from '../../components/login-order-for';
import LoginOtp from '../../components/login-otp';
import LoginSuccess from '../../components/login-success';
import { ROUTES as _routes } from '../../constants/app-constants';
import Modal from '../../containers/modal';
// import { getToken } from '../../burger-king-lib/redux/home/actions';
import { getLeftArrowImage } from '../../utils/imageChanges';
// import { SessionStorage } from '../../burger-king-lib/utils/storage';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
import { Analytics } from '../../helpers/analytics';
import {
  getEmailPayload,
  getGenerateOtpPayload,
  getOtpPayload,
  getSignUpPayload,
  getUserUpdatePayload
} from '../../payload-handling/login';
// import SocialLoginContainer from '../../containers/social-login';
import clevertap from 'clevertap-web-sdk';
import {
  get_otp,
  login_failed,
  login_successful,
  resend_otp,
  verify_otp
} from '../../../analyics_constants';
import { trackEvent } from '../../../analytics_wrapper';
import {
  LocalStorage,
  SessionStorage
} from '../../burger-king-lib/utils/storage.web';
import MOENGAGE_EVENTS_TRACKER from '../../../analatics/moengage/events';
import { customMoengageNames } from '../../../analatics/moengage/constants';
import { trackUserEvents } from '../../../analatics/moengage/userEvents';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProgress: 'mobileNumber',
      mobileNumberBtnTxt: 'Enter 10 digit phone number',
      mobileNumber: '',
      showBackdropLoader: false,
      verifyOtpError: '',
      otpError: false,
      showSocialLogin: true,
      email: '',
      facebookData: {},
      orderName: '',
      loginType: ''
    };
  }

  componentDidUpdate(prevProps) {
    const { loginData, homeData, theme } = this.props;
    const { mobileNumber, email } = this.state;
    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);

    if (loginData && loginData.signup !== prevProps.loginData.signup) {
      if (loginData.signup.error === 0) {
        this.setSignUpSuccesshandler();
      } else if (loginData.signup.error) {
        this.trackMoengageGetOtpEvent();
        alert(loginData.signup.message);
      }
      if (loginData.signup.message) this.hideBackDropLoader();
    }
    if (
      loginData &&
      loginData.signInWithEmail !== prevProps.loginData.signInWithEmail
    ) {
      if (loginData.signInWithEmail.error === 0) {
        this.verifyEmailUser(loginData.signInWithEmail.content);
      }
      if (loginData.signInWithEmail.error) {
        this.setOtpError(loginData.signInWithEmail.message);
      }
      if (loginData.signInWithEmail.message) this.hideBackDropLoader();
    }

    if (loginData && loginData.otp !== prevProps.loginData.otp) {
      if (loginData.otp.error === 0) {
        // this.onSignupVerify();
        this.setSignUpSuccesshandler();
      }
      if (loginData.otp.error) {
        this.setOtpError(loginData.otp.message);
        this.trackMoengageGetOtpEvent();
      }
      if (loginData.otp.message) this.hideBackDropLoader();
    }

    if (loginData && loginData.verifyOtp !== prevProps.loginData.verifyOtp) {
      if (loginData.verifyOtp.error === 0) {
        this.setVerifyOtpSuccessHandler(loginData.verifyOtp.content);
      }
      if (loginData.verifyOtp.error) {
        this.trackMoengageVerifyOtpEvent('failure');
        this.setOtpError(loginData.verifyOtp.message);
        trackEvent(login_failed, {
          order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
          city: addressInfo?.city,
          store_id: addressInfo?.outlet_id,
          mobile_no: mobileNumber,
          email: email,
          login_method: 'DESKTOP',
          crown_points: window.localStorage.getItem('crowns')
            ? window.localStorage.getItem('crowns')
            : 0
        });
      }
      if (loginData.verifyOtp.message) this.hideBackDropLoader();
    }

    if (loginData && loginData.updateUser !== prevProps.loginData.updateUser) {
      if (loginData.updateUser.error === 0) {
        this.updateUserHandler();
        this.getUserDetailData();
      } else if (loginData.updateUser.error) {
        alert(loginData.updateUser.message);
      }
      if (loginData.updateUser.message) this.hideBackDropLoader();
    }

    if (homeData && homeData.data !== prevProps.homeData.data) {
      if (homeData && homeData.data && homeData.data.content) {
        LocalStorage.set(
          LocalSessionKey.USER_ID,
          homeData.data.content.user_id
        );
        LocalStorage.set(LocalSessionKey.TOKEN, homeData.data.content.token);
        LocalStorage.set(
          LocalSessionKey.REFRESH_TOKEN,
          homeData.data.content.refresh_token
        );
        const {
          getUserDetailData,
          getCartItemData,
          tokenSuccessHandler
        } = this;
        // getUserDetailData();
        // getCartItemData();
        tokenSuccessHandler();
      }
    }
  }

  getUserDetailData = () => {
    const { getUserDetailData } = this.props;
    getUserDetailData();
  };

  // getTokenData = () => {
  //   const { getTokenData } = this.props;
  //   getTokenData();
  // };

  isNewUser = data => {
    const { is_new_user } = data;
    if (data && is_new_user) {
      // return true;
      this.setState({ isNewuser: true });
      window.sessionStorage.setItem('NEW_USER', 'true');
    }
    this.setState({ isNewuser: false });
    window.sessionStorage.setItem('NEW_USER', 'false');
  };

  setSignUpSuccesshandler = () => {
    const { theme } = this.props;
    const { mobileNumber } = this.state;
    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);

    this.setState({
      currentProgress: 'otp',
      mobileNumberBtnTxt: 'verify otp'
    });
    trackEvent(get_otp, {
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      city: addressInfo.city,
      store_id: addressInfo?.outlet_id,
      mobile_no: mobileNumber,
      crown_points: window.localStorage.getItem('crowns')
        ? window.localStorage.getItem('crowns')
        : 0
    });

    this.trackMoengageGetOtpEvent('success');
  };

  trackMoengageGetOtpEvent = (status = 'failure') => {
    MOENGAGE_EVENTS_TRACKER.get_otp({ status });
  };

  trackMoengageVerifyOtpEvent = (status, reason) => {
    MOENGAGE_EVENTS_TRACKER.verify_otp({
      status,
      reason
    });

    if (status === 'failure') return;
    MOENGAGE_EVENTS_TRACKER.login_successful({
      status,
      reason,
      login_method: 'phone number',
      login_date: new Date()
    });
  };

  verifyEmailUser = data => {
    const { is_new_user } = data;
    if (is_new_user) {
      this.setState({ showSocialLogin: false });
    } else {
      this.setVerifyOtpSuccessHandler(data);
    }
  };

  onSignupVerify = () => {
    const { mobileNumber } = this.state;
    const { getSignUpData } = this.props;
    const payload = getSignUpPayload(mobileNumber);
    getSignUpData(payload);
  };

  setVerifyOtpSuccessHandler = async data => {
    const {
      user_id,
      phone_no,
      name,
      bk_crowns,
      is_new_user,
      token,
      refresh_token
    } = data;
    const { email, loginType, showSocialLogin, isNewUser } = this.state;
    LocalStorage.set(LocalSessionKey.USER_ID, user_id);
    LocalStorage.set(LocalSessionKey.USER_DATA, phone_no);
    LocalStorage.set(LocalSessionKey.TOKEN, token);
    LocalStorage.set(LocalSessionKey.REFRESH_TOKEN, refresh_token);
    LocalStorage.set(LocalSessionKey.NAME, name);
    LocalStorage.set('crowns', bk_crowns);
    // this.getTokenData();
    // clevertap.onUserLogin.push({
    //   Site: {
    //     Crown_points: bk_crowns,
    //     DOB: data?.dob,
    //     Email: data.email ? data.email : '',
    //     Gender: data?.gender,
    //     Identity: phone_no,
    //     Login_method: 'DESKTOP',
    //     Name: name,
    //     Phone: `+91${phone_no}`,
    //     Platform: SessionStorage.get(LocalSessionKey.PLATFORM),
    //     birthdate_string: data?.dob,
    //     registration_date: data?.created_at
    //   }
    // });
    const { theme } = this.props;
    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
    trackEvent(verify_otp, {
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      city: addressInfo.city,
      store_id: addressInfo.outlet_id,
      mobile_no: data?.phone_no,
      crown_points: parseFloat(bk_crowns) ? parseFloat(bk_crowns) : 0
    });
    trackEvent(login_successful, {
      birthdate_string: data?.dob,
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      city: addressInfo.city,
      mobile_no: data?.phone_no,
      email: data?.email ? data?.email : '',
      first_name: data?.name,
      Login_method: 'DESKTOP',
      registration_date: data?.created_at,
      gender: data?.gender,
      crown_points: parseFloat(bk_crowns) ? parseFloat(bk_crowns) : 0,
      dob: data?.dob,
      Platform: SessionStorage.get(LocalSessionKey.PLATFORM)
    });

    this.updateUserData(data);
    this.isNewUser(data);

    trackUserEvents(customMoengageNames.userId, user_id);
    trackUserEvents(customMoengageNames.phoneNumber, data?.phone_no);
    trackUserEvents(customMoengageNames.isMember, !data?.is_new_user);
    trackUserEvents(customMoengageNames.lastLoginDate, data?.last_login);
    trackUserEvents(customMoengageNames.registrationDate, data?.created_at);
    trackUserEvents(customMoengageNames.crownPoints, data?.bk_crowns);
    trackUserEvents(customMoengageNames.dateOfBirth, data?.dob);

    this.trackMoengageVerifyOtpEvent('success', 'correct otp');

    if (data && data?.is_new_user) {
      const script = document.createElement('script');
      script.src = '//cdnt.netcoresmartech.com/smartechclient.js';
      script.onload = () => {
        smartech(
          'contact',
          6,
          { 'pk^mobile': phone_no, NAME: data.name },
          () => {
            smartech('identify', `${phone_no}`);
            smartech('dispatch', 'af_otpsubmit', { mobile: phone_no });
            smartech('dispatch', 'af_register', {
              NAME: data.name,
              mobile: phone_no
            });
          }
        );
      };
      document.head.appendChild(script);
      if (loginType === 'fb') {
        Analytics.logEventWithVariable(
          Analytics.Order.fbLogin,
          JSON.stringify({
            NAME: data.name,
            mobile: phone_no,
            user: 'new_user',
            email: data.email || email
          })
        );
      } else if (loginType === 'google') {
        Analytics.logEventWithVariable(
          Analytics.Order.googleLogin,
          JSON.stringify({
            NAME: data.name,
            mobile: phone_no,
            user: 'new_user',
            email: data.email || email
          })
        );
      } else {
        Analytics.logEventWithVariable(
          Analytics.Order.login,
          JSON.stringify({
            NAME: data.name,
            mobile: phone_no,
            user: 'new_user',
            email: data.email || email
          })
        );
      }
      const fbscript = document.createElement('script');
      fbscript.src = '//connect.facebook.net/en_US/fbevents.js';
      fbscript.onload = () => {
        fbq('track', 'CompleteRegistration', {
          NAME: data.name,
          mobile: phone_no,
          currency: 'INR',
          value: 0,
          email: data.email || email
        });
      };
      document.head.appendChild(fbscript);
      this.setState({
        currentProgress: 'orderFor',
        mobileNumberBtnTxt: 'done'
      });
    } else {
      const script = document.createElement('script');
      script.src = '//cdnt.netcoresmartech.com/smartechclient.js';
      script.onload = () => {
        smartech(
          'contact',
          6,
          {
            'pk^mobile': phone_no,
            NAME: data.name,
            mobile: phone_no,
            email: data.email
          },
          () => {
            smartech('identify', `${phone_no}`);
            smartech('dispatch', 'af_otpsubmit', { mobile: phone_no });
            smartech('dispatch', 'af_login', {
              NAME: data.name,
              mobile: phone_no,
              email: data.email
            });
          }
        );
      };
      document.head.appendChild(script);
      if (loginType === 'fb') {
        Analytics.logEventWithVariable(
          Analytics.Order.fbLogin,
          JSON.stringify({
            NAME: data.name,
            mobile: phone_no,
            email: data.email || email,
            user: 'existing_user'
          })
        );
      } else if (loginType === 'google') {
        Analytics.logEventWithVariable(
          Analytics.Order.googleLogin,
          JSON.stringify({
            NAME: data.name,
            mobile: phone_no,
            email: data.email || email,
            user: 'existing_user'
          })
        );
      } else {
        Analytics.logEventWithVariable(
          Analytics.Order.login,
          JSON.stringify({
            NAME: data.name,
            mobile: phone_no,
            email: data.email || email,
            user: 'existing_user'
          })
        );
      }
      this.updateUserHandler();
    }
    const fbscript = document.createElement('script');
    fbscript.src = '//connect.facebook.net/en_US/fbevents.js';
    fbscript.onload = () => {
      fbq('track', 'Contact', { name: data.name, mobile: phone_no });
    };
    document.head.appendChild(fbscript);
    this.setState({
      showBackdropLoader: false
    });
    this.getUserDetailData();
  };

  tokenSuccessHandler = () => {
    const { isNewUser } = this.state;
    if (isNewUser) {
      const { location } = this.props;
      if (location.search !== '?screen_type=login') {
        this.setState({
          currentProgress: 'orderFor',
          mobileNumberBtnTxt: 'done'
        });
      }
    } else {
      this.updateUserHandler();
    }
    this.setState({ verifyOtpError: '' });
  };

  getCartItemData = () => {
    // const { getCartItemData, theme } = this.props;
    // const payload = getCartItemPayload(theme);
    // getCartItemData(payload);
  };

  setOtpError = message => {
    this.setState({ verifyOtpError: message });
    if (message === 'Request new OTP') {
      this.setState({ verifyOtpError: message, otpError: true });
      return;
    }
  };

  hideBackDropLoader = () => {
    this.setState({ showBackdropLoader: false });
  };

  updateUserData = data => {
    const { loggedInToggleHandler } = this.props;
    const { phone_no } = data;
    LocalStorage.set(LocalSessionKey.USER_DATA, phone_no);
    this.setState({ showBackdropLoader: true });
    loggedInToggleHandler(data);
  };

  onLoginChangeHandler = text => {
    this.setState({ mobileNumberBtnTxt: text });
  };

  onGetOtpClickHandler = number => {
    const { getSignUpData } = this.props;
    const payload = getSignUpPayload(number);
    getSignUpData(payload);
    this.setState({ mobileNumber: number, showBackdropLoader: true });
  };

  onVerifyOtpClickHandler = value => {
    const { getOtpData } = this.props;
    const { mobileNumber, email } = this.state;
    this.setState({ showBackdropLoader: true });
    const successCallback = response => {
      this.setState({ showBackdropLoader: false });
      this.setVerifyOtpSuccessHandler(response?.data?.content);
    };

    const errorCallback = async error => {
      const { theme } = this.props;
      const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
      this.trackMoengageVerifyOtpEvent('failure', error?.data?.message || '');
      console.log('Error:', error);
      this.setState({ showBackdropLoader: false });
      this.setOtpError(error?.data?.message);
      trackEvent(login_failed, {
        order_mode: theme,
        city: addressInfo?.city,
        store_id: addressInfo?.outlet_id,
        mobile_no: mobileNumber,
        email: email,
        login_method: 'DESKTOP',
        crown_points: window.localStorage.getItem('crowns')
          ? window.localStorage.getItem('crowns')
          : 0
      });
    };
    const payload = getOtpPayload(mobileNumber, value);
    getOtpData({ ...payload, successCallback, errorCallback });
  };

  onDoneClickHandler = name => {
    const { orderName } = this.state;
    let names = name;
    if (name === '' && orderName.length > 0) {
      names = orderName;
    }

    trackUserEvents(customMoengageNames.name, name);

    const { getUpdateUserData } = this.props;
    const payload = getUserUpdatePayload(names);
    MOENGAGE_EVENTS_TRACKER.registration_succesfull({
      name,
      registration_date: new Date(),
      login_method: 'Phone number',
      reason: 'New user',
      status: 'success'
    });
    getUpdateUserData(payload);
  };

  updateUserHandler = () => {
    const { onLoginSuccessHandler } = this.props;
    this.setState({ currentProgress: 'success' });
    setTimeout(() => onLoginSuccessHandler(), 1500);
  };

  onPrivacyPolicy = () => {
    const { history, onLoginSuccessHandler } = this.props;
    const { innerWidth } = window;
    if (innerWidth > 1023) {
      history.push(`${_routes.PRIVACY_POLICY_LINK}`);
    } else {
      history.push(`${_routes.PRIVACY_POLICY}`);
    }
    onLoginSuccessHandler();
  };

  onTermsPolicy = () => {
    const { history, onLoginSuccessHandler } = this.props;
    const { innerWidth } = window;
    if (innerWidth > 1023) {
      history.push(`${_routes.TERMS}`);
    } else {
      history.push(`${_routes.TERMS_AND_CONDITIONS}`);
    }
    onLoginSuccessHandler();
  };

  onChangeClickHandler = () => {
    this.setState({ currentProgress: 'mobileNumber' });
  };

  onFacebookLogin = data => {
    const { signUpWithEmailData } = this.props;
    this.setState({
      email: data.data.email,
      facebookData: data.data,
      orderName: data.data.name,
      loginType: 'fb'
    });
    const payload = getEmailPayload(data.data.email, data.data.accessToken);
    signUpWithEmailData(payload);
  };

  onGoogleLogin = data => {
    // console.log(data, 'data');
    const profile = data.profileObj;
    const { signUpWithEmailData } = this.props;
    this.setState({
      email: profile.email,
      facebookData: profile,
      orderName: profile.name,
      loginType: 'google'
    });
    const payload = getEmailPayload(profile.email, data.accessToken);
    signUpWithEmailData(payload);
  };

  resendOtpClickHandler = () => {
    const { mobileNumber } = this.state;
    const { onGetOtpClickHandler } = this;
    const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
    const { theme } = this.props;
    onGetOtpClickHandler(mobileNumber);
    alert('OTP has been sent');
    this.setState({ verifyOtpError: '', otpError: false });
    trackEvent(resend_otp, {
      order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
      city: addressInfo.city,
      store_id: addressInfo?.outlet_id,
      mobile_no: mobileNumber,
      crown_points: window.localStorage.getItem('crowns')
        ? window.localStorage.getItem('crowns')
        : 0
    });

    MOENGAGE_EVENTS_TRACKER.resend_otp({ status: 'success' });
  };

  onContentPolicy = () => {
    const { history, onLoginSuccessHandler } = this.props;
    const { innerWidth } = window;
    if (innerWidth > 1023) {
      history.push(`${_routes.PROMOTIONAL_PRIVACY_POLICY_LINK}`);
    } else {
      history.push(`${_routes.PPROMOTIONAL_PRIVACY_POLICY_LINK}`);
    }
    onLoginSuccessHandler();
  };

  generateData = number => {
    const { generatePhoneOtpData, loginData } = this.props;
    const { email } = this.state;
    const payload = getGenerateOtpPayload(email, number);
    generatePhoneOtpData(payload);
    this.setState({ mobileNumber: number, showBackdropLoader: true });
  };

  renderContent = () => {
    const {
      currentProgress,
      mobileNumberBtnTxt,
      mobileNumber,
      verifyOtpError,
      otpError,
      showSocialLogin,
      orderName,
      email
    } = this.state;
    const { theme } = this.props;
    let dom = null;
    switch (currentProgress) {
      case 'mobileNumber':
        dom = (
          <>
            <LoginNumber
              theme={theme}
              onClick={
                email !== '' && !showSocialLogin
                  ? this.generateData
                  : this.onGetOtpClickHandler
              }
              mobileNumberBtnTxt={mobileNumberBtnTxt}
              onChange={this.onLoginChangeHandler}
              onFacebookLogin={this.onFacebookLogin}
              responseGoogle={this.onGoogleLogin}
              showSocialLogin={showSocialLogin}
            />
          </>
        );
        break;
      case 'otp':
        dom = (
          <LoginOtp
            theme={theme}
            verifyOtpError={verifyOtpError}
            resendOtpClickHandler={this.resendOtpClickHandler}
            mobileNumber={mobileNumber}
            onVerifyOtpClick={this.onVerifyOtpClickHandler}
            onChangeClick={this.onChangeClickHandler}
            otpDisable={otpError}
            onFacebookLogin={this.onFacebookLogin}
            responseGoogle={this.onGoogleLogin}
            showSocialLogin={showSocialLogin}
          />
        );
        break;
      case 'orderFor':
        dom = (
          <LoginOrder
            theme={theme}
            onOrderClick={this.onDoneClickHandler}
            mobileNumberBtnTxt={mobileNumberBtnTxt}
            orderName={orderName}
          />
        );
        break;
      case 'success':
        dom = <LoginSuccess />;
        break;
      default:
        dom = '';
    }

    return dom;
  };

  onLoginClosehandler = () => {
    const { showSocialLogin, currentProgress } = this.state;
    const { onLoginSuccessHandler } = this.props;
    if (!showSocialLogin && currentProgress === 'mobileNumber') {
      LocalStorage.remove(LocalSessionKey.USER_ID);
      // this.getTokenData();
    }
    onLoginSuccessHandler();
  };

  render() {
    const { renderContent } = this;
    const { theme } = this.props;
    const { showBackdropLoader, currentProgress } = this.state;
    const { innerWidth } = window;

    return (
      <Modal
        isMobileFullLayout={innerWidth < 1023}
        hideClose
        contentDataCustomClass={`login-pg_content ${currentProgress ===
          'success' && 'success'}`}
        contentCustomClass={innerWidth >= 1023 && 'login-pg_data'}
        fullWidth
      >
        <div
          className={`login-pg_wrapper ${currentProgress === 'success' &&
            'success'}`}
        >
          <div
            className={`login-pg ${currentProgress === 'success' && 'success'}`}
          >
            {currentProgress !== 'success' && (
              <div className="login-pg_close">
                <img
                  src={getLeftArrowImage(theme)}
                  width="18"
                  height="18"
                  onClick={this.onLoginClosehandler}
                />
                {/* <div
                  className="login-pg_close_icon takeaway"
                  onClick={this.onLoginClosehandler}
                ></div> */}
              </div>
            )}
            {renderContent()}
            {currentProgress !== 'success' && (
              <div className="login-pg_footer">
                <p className="login-pg_footer_content">
                  By continuing, you agree for our{' '}
                  <u onClick={this.onTermsPolicy}>Terms & Conditions,</u>{' '}
                  <u onClick={this.onPrivacyPolicy}>Privacy Policy,</u> and{' '}
                  <u onClick={this.onContentPolicy}>Promotional T&C</u>
                </p>
              </div>
            )}
          </div>
          {showBackdropLoader ? <Loader theme={theme} /> : ''}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    loginData: state.login,
    homeData: state.home
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSignUpData: payloadData => dispatch(getSignup(payloadData)),
    getOtpData: payloadData => dispatch(getVerifyOtp(payloadData)),
    getUpdateUserData: payloadData => dispatch(getUpdateUser(payloadData)),
    // getCartItemData: payloadData => dispatch(getCartItem(payloadData)),
    getUserDetailData: payloadData => dispatch(getUserDetail(payloadData)),
    // getTokenData: payloadData => dispatch(getToken(payloadData)),
    signUpWithEmailData: payloadData => dispatch(signUpWithEmail(payloadData)),
    generatePhoneOtpData: payloadData => dispatch(generatePhoneOtp(payloadData))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
